import { SnackbarToToastConfig, SnackbarToToastTypes } from '../types';
import { TOAST_TYPES } from './toastTypes';

const getSnackbarTypeMapper = new Map<SnackbarToToastTypes | undefined, SnackbarToToastConfig>([
  [TOAST_TYPES.success, { variantColor: 'green', autoClose: 4000 }],
  [TOAST_TYPES.successPermanent, { variantColor: 'green', autoClose: false }],
  [TOAST_TYPES.error, { variantColor: 'red', autoClose: false }],
  [TOAST_TYPES.warning, { variantColor: 'yellow', autoClose: 6000 }],
  [TOAST_TYPES.info, { variantColor: 'grey', autoClose: 6000 }],
]);

export const snackbarType = (type?: SnackbarToToastTypes) => getSnackbarTypeMapper.get(type);
